import { render, staticRenderFns } from "./ViewCurrent.vue?vue&type=template&id=3ac53554&"
import script from "./ViewCurrent.vue?vue&type=script&lang=ts&"
export * from "./ViewCurrent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ac53554')) {
      api.createRecord('3ac53554', component.options)
    } else {
      api.reload('3ac53554', component.options)
    }
    module.hot.accept("./ViewCurrent.vue?vue&type=template&id=3ac53554&", function () {
      api.rerender('3ac53554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/ViewCurrent.vue"
export default component.exports